import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Wrapper from 'base/wrapper.js';
import ajaxWrapper from 'base/ajax.js';
import format_date_string from 'base/date_string_format.js';

class ListBillings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billings: [],
      companyOptions: [],

      title: '',
      company: '',
      status: '',

      page_offset: 1,
      limit: 10,
      total_count: 0,
      page_count: 0,
      loaded: false,
    };
  }

  /* =========================
     LIFECYCLE
     ========================= */

  componentDidMount() {
    // load only for admin
    if (this.props.user.company_id === 'e4f3c0a1-5e41-4541-98e4-8288353c7684') {
      this.loadCompanies(); 
    }
    this.fetchBillings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page_offset !== this.state.page_offset ||
      prevState.limit !== this.state.limit ||
      prevState.title !== this.state.title ||
      prevState.company !== this.state.company ||
      prevState.status !== this.state.status
    ) {
      this.fetchBillings();
    }
  }

  /* =========================
     API CALLS
     ========================= */

  loadCompanies = () => {
    ajaxWrapper(
      'GET',
      '/api/companies/?page_size=1000',
      {},
      (res) => {
        const options = res.results.map(r => ({
          value: r.company.id,
          text: r.company.name
        }));
        this.setState({ companyOptions: options });
      }
    );
  };

  fetchBillings = () => {
    const isAdmin = this.props.user.company_id === 'e4f3c0a1-5e41-4541-98e4-8288353c7684';
    const companyFilter = isAdmin ? this.state.company : this.props.user.company_id;
    ajaxWrapper(
      'GET',
      '/api/billings/',
      {
        page: this.state.page_offset,
        page_size: this.state.limit,
        title: this.state.title || undefined,
        company: companyFilter || undefined,
        is_paid: this.state.status || undefined,
      },
      (res) => {
        this.setState({
          billings: res.results,
          total_count: res.count,
          page_count: Math.ceil(res.count / this.state.limit),
          loaded: true,
        });
      }
    );
  };

  /* =========================
     HANDLERS
     ========================= */

  handlePageClick = (e) => {
    this.setState({ page_offset: e.selected + 1 });
  };

  handleLimitChange = (e) => {
    this.setState({
      limit: parseInt(e.target.value),
      page_offset: 1,
    });
  };

  handleFilterChange = (name, value) => {
    this.setState({
      [name]: value,
      page_offset: 1,
    });
  };

  mark_as_paid(billing){
    if(this.props.user.company_id != 'e4f3c0a1-5e41-4541-98e4-8288353c7684'){
        return;
    }

    if(window.confirm('Are you sure you want to mark billing as paid') == false){
        return;
    }

    ajaxWrapper(
        'POST',
        `/api/home/billing/${billing.id}/`,
        { is_paid: true },
        (res) => {
          console.log('mark_as_paid res', res);
          const updatedBilling = res && res[0] ? res[0].billing : null;

          if (!updatedBilling) {
            return;
          }

          this.setState(prevState => ({
            billings: prevState.billings.map(iter => {
              if (iter.billing.id === billing.id) {
                console.log('matched paid_at:', updatedBilling.paid_at);
                console.log('matched formatted paid_at:', format_date_string(updatedBilling.paid_at, 'mm/dd/yyyy', false));

                return {
                  ...iter,
                  billing: {
                    ...iter.billing,
                    is_paid: updatedBilling.is_paid,
                    paid_at: format_date_string(updatedBilling.paid_at, 'mm/dd/yyyy', false),
                  },
                };
              }

              return iter;
            })
          }));
        }
    );
}


  /* =========================
     RENDER
     ========================= */

  render() {
    return (
      <Wrapper
        loaded={this.state.loaded}
        content={
          <div className="container-fluid">

            {/* ================= FILTERS ================= */}
            <div className="row" style={{ marginBottom: "15px" }}>
  <div className="col-sm-4">
    <label>Title</label>
    <input
      className="form-control"
      value={this.state.title}
      onChange={(e) =>
        this.setState({ title: e.target.value, page_offset: 1 })
      }
    />
  </div>

  <div className="col-sm-4">
    <label>Law Firm</label>
    <select
      className="form-control"
      value={this.state.company}
      onChange={(e) =>
        this.setState({ company: e.target.value, page_offset: 1 })
      }
    >
      <option value="">All</option>
      {this.state.companyOptions.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.text}
        </option>
      ))}
    </select>
  </div>

  <div className="col-sm-4">
    <label>Status</label>
    <select
      className="form-control"
      value={this.state.status}
      onChange={(e) =>
        this.setState({ status: e.target.value, page_offset: 1 })
      }
    >
      <option value="">All</option>
      <option value="true">Paid</option>
      <option value="false">Not Paid</option>
    </select>
  </div>
</div>

            {/* ================= PAGINATION (TOP – SAME AS COMPANY LIST) ================= */}
            {/* PAGINATION */}
<div style={{ margin: "20px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
  <div>Total Records : {this.state.total_count}</div>

  <div style={{ display: "flex", alignItems: "center", marginLeft: "20px" }}>
    <select
      className="form-control"
      style={{ width: "85px", marginRight: "5px" }}
      value={this.state.limit}
      onChange={this.handleLimitChange}
    >
      <option>10</option>
      <option>20</option>
      <option>30</option>
      <option>40</option>
      <option>50</option>
      <option>100</option>
    </select>

    <ReactPaginate
      breakLabel="..."
      nextLabel="Next"
      previousLabel="Previous"
      onPageChange={this.handlePageClick}
      pageRangeDisplayed={10}
      marginPagesDisplayed={3}
      pageCount={this.state.page_count}
      forcePage={this.state.page_offset - 1}
      className="custom-pagination"
    />
  </div>
</div>


            {/* ================= TABLE ================= */}
            <table className="table">
              <thead>
                <tr>
                <th width='30%'>Title</th> 
                <th width='20%'>Company</th> 
                <th className='text-center' width='20%'>Status</th> 
                <th className='text-center' width='15%'>Created At</th> 
                <th className='text-center' width='15%'>Paid At</th>
                </tr>
              </thead>
              <tbody>
                {this.state.billings.map(row => (
                  <tr key={row.billing.id}>
                    <td>
                      <a href={`/invoice/${row.billing.company.id}/${row.billing.id}`}>
                        {row.billing.title || 'Untitled'}
                      </a>
                    </td>
                    <td>{row.billing.company.name}</td>
                    <td className='text-center'> 
                      { row.billing.is_paid ? <button className="btn btn-success"> Paid </button> 
                      : <button className="btn btn-danger" onClick={() => this.mark_as_paid(row.billing)}> 
                      Not Paid </button> } </td>


                      <td className='text-center'> { row.billing.created_at ? format_date_string(row.billing.created_at, 'mm/dd/yyyy', false) : '' } </td> 
                      <td className='text-center'> { row.billing.is_paid ? format_date_string(row.billing.paid_at, 'mm/dd/yyyy', false) : '-' } </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </div>
        }
      />
    );
  }
}

export default ListBillings;
